module.exports = __webpack_public_path__ + "static/media/desmos-bg-cover.c472ca61.jpg";